
import styles from '../../assets/styles/Settings/Settings.module.scss';
import { MimaButton, MimaInput, MimaText, Modal, MimaDropdown, PageLoader } from '../../components';
import React, { useState } from 'react';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import { userStore, useStores } from '../../stores';
import { BsCheck } from 'react-icons/bs';
import { toJS } from 'mobx';
import OtpInput from 'react-otp-input';
import OtpForm from '../OTP/OTPForm';


const NumberVerification = ({
    sendToken,
    handleOtpSubmit,
    page,
    loading,
    closeModal,
    validationSchema,
}) => {
    return (
        <Modal closeModal={closeModal}>
            <MimaText variant="subtitleBold" mb={4} align="center" color="var(--color-primary)">Number Verification</MimaText>

            {page === "NUMB" && (
                <Formik
                    initialValues={{
                        mobile: "",
                    }}
                    validationSchema={validationSchema}
                    onSubmit={sendToken}
                >
                    {({
                        handleSubmit,
                        handleBlur,
                        setFieldValue,
                        handleChange,
                        touched,
                        values,
                        errors,
                    }) => (
                        <>
                            {/* <MimaText variant="smallBold" mt={2}>Enter Business phone number</MimaText> */}
                            <MimaInput
                                labelTitle="Enter Business phone number"
                                name="mobile"
                                placeholder="Enter phone number"
                                value={values.mobile}
                                onChange={handleChange}
                                error={touched.mobile && errors.mobile}
                                touched={touched.mobile}
                                onBlur={handleBlur}
                            />

                            <MimaButton
                                title="Continue"
                                onClick={() => {
                                    handleSubmit();
                                }}
                                loading={loading}
                            />
                        </>

                    )}
                </Formik>
            )}

            {page === "TOKEN" && (
                <>
                    <>
                        <MimaText variant="small" align="center">
                            To make sure we’ve got your details right,
                            <br />
                            we’ve sent a 5 digit code to your business phone number
                        </MimaText>
                        <MimaText mb={2} variant="smallBold" color="var(--color-primary)" align="center">
                            Please enter the code below
                        </MimaText>
                    </>
                    <Formik initialValues={{
                        smsToken: "",
                    }}
                        onSubmit={handleOtpSubmit}>
                        <Form>
                            <Field name="smsToken">
                                {({ field }) => (
                                    <OtpInput
                                        {...field}
                                        numInputs={5}
                                        isInputNum
                                        shouldAutoFocus
                                        onChange={(smsToken) => {
                                            field.onChange({
                                                target: {
                                                    name: field.name,
                                                    value: smsToken
                                                }
                                            });
                                        }}
                                        inputStyle={{
                                            fontSize: '2.4rem',
                                            fontFamily: 'inherit',
                                            width: '6rem',
                                            height: '6rem',
                                            margin: '1rem',
                                            borderTop: '0px',
                                            border: '1px solid #4A4A68',
                                            borderRadius: '1rem',
                                            display: 'block',
                                            outline: 'none',
                                            textAlign: 'center',
                                        }}
                                    />
                                )}
                            </Field>
                            <ErrorMessage name="smsToken" component="div" />
                            <div style={{ display: "flex", justifyContent: "center" }}>
                                <MimaButton
                                    title="Verify Token"
                                    type="submit"
                                    mt={4}
                                    loading={loading}
                                />
                            </div>
                        </Form>
                    </Formik>

                </>
            )}

        </Modal>
    )
}
export default NumberVerification;
